import { useState } from 'react';

export default function FAQSection() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(0);

  const faqs = [
    {
      question: "¿Qué incluye la prueba gratuita de 30 días?",
      answer: "La prueba gratuita incluye acceso completo a todas las características premium de AbiSoft Explorer: búsqueda avanzada, vista previa de archivos, organización automática, sincronización en la nube, y soporte técnico. No hay limitaciones ni restricciones durante el período de prueba."
    },
    {
      question: "¿Necesito tarjeta de crédito para la prueba?",
      answer: "No, absolutamente no necesitas proporcionar información de tarjeta de crédito para comenzar tu prueba gratuita de 30 días. Simplemente descarga la aplicación y comienza a usar todas las características inmediatamente."
    },
    {
      question: "¿Qué pasa después de los 30 días?",
      answer: "Después de los 30 días, podrás continuar usando AbiSoft Explorer con una suscripción anual de solo $30 USD. Si decides no continuar, tu acceso premium expirará pero no perderás ningún archivo ni configuración."
    },
    {
      question: "¿Puedo cancelar mi suscripción en cualquier momento?",
      answer: "Sí, puedes cancelar tu suscripción en cualquier momento desde tu panel de usuario. No hay contratos a largo plazo ni penalizaciones por cancelación. Tu acceso continuará hasta el final del período pagado."
    },
    {
      question: "¿AbiSoft Explorer funciona sin conexión a internet?",
      answer: "Sí, AbiSoft Explorer funciona completamente sin conexión para todas las operaciones de archivos locales. Solo necesitas conexión para la sincronización en la nube, actualizaciones y algunas características de IA."
    },
    {
      question: "¿Qué sistemas operativos son compatibles?",
      answer: "AbiSoft Explorer está disponible para Windows 10/11, macOS 10.14+, y próximamente para iOS y Android. También ofrecemos versiones para Linux Ubuntu y otras distribuciones principales."
    },
    {
      question: "¿Con qué frecuencia reciben actualizaciones?",
      answer: "Lanzamos actualizaciones menores cada 2-3 semanas con mejoras y correcciones. Las actualizaciones principales con nuevas características se lanzan mensualmente. Todas las actualizaciones están incluidas en tu suscripción."
    },
    {
      question: "¿Mis archivos están seguros?",
      answer: "Absolutamente. Utilizamos encriptación AES-256 para todos los archivos sincronizados, autenticación de dos factores, y respaldos automáticos. Tus archivos locales permanecen en tu dispositivo y solo se sincronizan si tú lo permites."
    },
    {
      question: "¿Puedo usar AbiSoft Explorer en múltiples dispositivos?",
      answer: "Sí, tu suscripción incluye acceso en hasta 5 dispositivos simultáneamente con sincronización automática entre todos ellos. Perfecto para uso personal y profesional."
    },
    {
      question: "¿Ofrecen descuentos para equipos o empresas?",
      answer: "Sí, ofrecemos precios especiales para equipos de 5+ usuarios y licencias empresariales con características adicionales de administración y seguridad. Contáctanos para obtener una cotización personalizada."
    }
  ];

  return (
    <section id="faq" className="py-20 bg-gray-50 dark:bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200 rounded-full text-sm font-medium mb-4">
            PREGUNTAS FRECUENTES
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            ¿Tienes dudas? Te ayudamos
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Encuentra respuestas rápidas a las preguntas más comunes sobre AbiSoft Explorer
          </p>
        </div>

        {/* FAQ Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-6xl mx-auto">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden"
            >
              <button
                onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white pr-4">
                  {faq.question}
                </h3>
                <i className={`ri-${openFAQ === index ? 'subtract' : 'add'}-line text-xl text-gray-500 flex-shrink-0 transition-transform duration-200`}></i>
              </button>
              
              {openFAQ === index && (
                <div className="px-6 pb-5">
                  <div className="pt-2 border-t border-gray-200 dark:border-gray-700">
                    <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="text-center mt-16 p-8 bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-900/20 dark:to-purple-900/20 rounded-2xl border border-blue-200 dark:border-blue-700">
          <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
            ¿No encontraste tu respuesta?
          </h3>
          <p className="text-gray-600 dark:text-gray-300 mb-6">
            Nuestro equipo de soporte está listo para ayudarte con cualquier pregunta específica
          </p>
          <button className="px-8 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all whitespace-nowrap cursor-pointer">
            Contactar Soporte
          </button>
        </div>
      </div>
    </section>
  );
}